var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#1A5AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0009 21.4299C20.4106 21.4299 20.8163 21.3492 21.1948 21.1924C21.5734 21.0357 21.9173 20.8058 22.207 20.5161C22.4968 20.2264 22.7266 19.8824 22.8834 19.5039C23.0402 19.1254 23.1209 18.7197 23.1209 18.3099C23.1209 17.9002 23.0402 17.4945 22.8834 17.116C22.7266 16.7374 22.4968 16.3935 22.207 16.1038C21.9173 15.814 21.5734 15.5842 21.1948 15.4274C20.8163 15.2706 20.4106 15.1899 20.0009 15.1899C19.1734 15.1899 18.3798 15.5187 17.7947 16.1038C17.2096 16.6889 16.8809 17.4825 16.8809 18.3099C16.8809 19.1374 17.2096 19.931 17.7947 20.5161C18.3798 21.1012 19.1734 21.4299 20.0009 21.4299Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6197 16.49C13.5897 7.83 26.4197 7.84 28.3797 16.5C29.5297 21.58 26.3697 25.88 23.5997 28.54C22.6318 29.4735 21.3395 29.9952 19.9947 29.9952C18.65 29.9952 17.3576 29.4735 16.3897 28.54C13.6297 25.88 10.4697 21.57 11.6197 16.49Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIc);
export default __webpack_public_path__ + "static/media/address_ic.475dc5067fc8adf3135550426bed85db.svg";
export { ForwardRef as ReactComponent };